if (!customElements.get("m-sharing")) {
  customElements.define(
    "m-sharing",
    class MSharing extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          shareContent: ".m-product-addon--sharing",
          openBtn: "[data-open-share]",
        };
      }

      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        const { shareContent } = this.domNodes;
        if (shareContent && shareContent.innerHTML) {
          this.shareContent = shareContent.innerHTML;
          this.init();
        }
      }

      /* Datos que se envian a la hoja nativa de compartir */
      getSharePayload() {
        const h1 = document.querySelector(".m-product-title");
        const og = document.querySelector('meta[property="og:title"]');
        const name =
          (h1 && h1.textContent.trim()) ||
          (og && og.getAttribute("content")) ||
          document.title;

        /* URL limpia (sin parametros de seguimiento), conservando la variante elegida */
        const current = new URL(window.location.href);
        const clean = new URL(current.origin + current.pathname);
        const variant = current.searchParams.get("variant");
        if (variant) clean.searchParams.set("variant", variant);

        const isEnglish = (document.documentElement.lang || "").toLowerCase().indexOf("en") === 0;
        const text = isEnglish
          ? "Take a look at " + name + " by Puro Nicho"
          : "Mira " + name + " de Puro Nicho";

        return { title: name + " – Puro Nicho", text: text, url: clean.toString() };
      }

      /* Ventana clasica del tema (copiar enlace + redes) */
      openFallbackModal() {
        if (!this.shareContent) return;
        const html = document.createElement("DIV");
        html.classList.add("m-sharing__content");
        html.innerHTML = this.shareContent;
        this.modal.appendChild(html);
        const colorScheme = html.querySelector("[data-color-scheme]") && html.querySelector("[data-color-scheme]").dataset.colorScheme;
        this.modal.setSizes(`m-sharing m-gradient ${colorScheme}`);
        this.modal.open();
      }

      /* Hoja nativa solo en moviles/tablets tactiles (iPhone, iPad, Android) */
      canUseNativeShare() {
        return (
          typeof navigator.share === "function" &&
          window.matchMedia &&
          window.matchMedia("(pointer: coarse)").matches
        );
      }

      init() {
        this.domNodes.openBtn && this.domNodes.openBtn.classList.remove("m:hidden");
        this.modal = new MinimogTheme.Modal();
        addEventDelegate({
          selector: this.selectors.openBtn,
          handler: (e) => {
            e.preventDefault();
            if (this.canUseNativeShare()) {
              navigator.share(this.getSharePayload()).catch((err) => {
                /* Si la persona cierra la hoja no hacemos nada; si falla de verdad, ventana clasica */
                if (err && err.name === "AbortError") return;
                this.openFallbackModal();
              });
              return;
            }
            this.openFallbackModal();
          },
        });
      }
    }
  );
}
